import React, { useEffect, useState } from "react";
import { useContext } from "react";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";
import { serverInfo } from "../../App";
import Nodata from "../Reuseable/Nodata";
import noImage from "../../assets/images/BannerAuditionAdmin.png";
const AuditionCardReuse = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const [currentItems, setCurrentItems] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 8;
  const {
    data,
    urlLink,
    url2,
    urlLinkInstruction,
    urlLinkFeedback,
    handleAcceptReject,
    viewPostUrl,
    distributeUrlLink,
    roundInstruction,
    isMyGroupPrimary,
  } = props;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(data.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(data.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, data]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % data.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      {currentItems.length === 0 ? (
        <Nodata />
      ) : (
        <>
          {" "}
          <div className="py-3">
            <div className="row">
              {currentItems.map((event_data) => {
                return (
                  <>
                    <div className="col-sm-12 col-md-6 col-lg-3 mb-3 p-3">
                      <div className="card card-bg completedMeetupBlack ">
                        <img
                          src={
                            event_data.banner
                              ? imageCdnUrl + event_data.banner
                              : noImage
                          }
                          className="img-fluid p-2 ImgBlue"
                          style={{ height: "200px", width: "100%" }}
                          alt=""
                        />
                        <div className="p-3">
                          <center>
                            <h4 className="text-white text-center fw-bolder title-limit">
                              <i>{event_data.title ?? ""}</i>
                            </h4>

                            {url2 ? (
                              <>
                                <Link to={`${urlLink}/${event_data.slug}`}>
                                  <button className="btn btnConfirm btnTest fw-bold w-100 my-2">
                                    Action
                                  </button>
                                </Link>
                                <Link to={`${url2}/${event_data.slug}`}>
                                  <button className="btn btnTest w-100 fw-bold btnEditTest my-2">
                                    Instruction Feedback
                                  </button>
                                </Link>
                              </>
                            ) : (
                              <>
                                {urlLink && (
                                  <Link to={`${urlLink}/${event_data.slug}`}>
                                    {" "}
                                    <button className="btn btnEditTest btnTest fw-bold my-2 w-100">
                                      Filter Video
                                    </button>
                                  </Link>
                                )}
                                {roundInstruction && (
                                  <Link
                                    to={`${roundInstruction}/${event_data.slug}`}
                                  >
                                    {" "}
                                    <button className="btn btnEditTest btnTest fw-bold my-2 w-100">
                                      Round Instruction
                                    </button>
                                  </Link>
                                )}

                                {viewPostUrl && (
                                  <Link
                                    to={`${viewPostUrl}/${event_data.slug}`}
                                  >
                                    {" "}
                                    <button className="btn btnEditTest btnTest fw-bold my-2 w-100">
                                      View Post
                                    </button>
                                  </Link>
                                )}
                                {urlLinkInstruction && (
                                  <Link
                                    to={`${urlLinkInstruction}/${event_data.slug}`}
                                  >
                                    {" "}
                                    <button className="btn btnEditTest fw-bold btnTest w-100 my-2 w-100">
                                      Make Round Instructions
                                    </button>
                                  </Link>
                                )}
                                {urlLinkFeedback && (
                                  <Link
                                    to={`${urlLinkFeedback}/${event_data.slug}`}
                                  >
                                    {" "}
                                    <button className="btn btnJoinNow fw-bold btnTest w-100 my-2 w-100">
                                      Star Feedback Instructions
                                    </button>
                                  </Link>
                                )}
                                {handleAcceptReject && (
                                  <div className="row">
                                    <div className="col-md-6">
                                      <button
                                        className="btn btnConfirm fw-bold btnTest w-100 mb-2"
                                        onClick={(e) =>
                                          handleAcceptReject(event_data.id, 1)
                                        }
                                      >
                                        Accept
                                      </button>
                                    </div>
                                    <div className="col-md-6">
                                      <button
                                        className="btn btnEditTest btnTest fw-bold w-100 mb-2"
                                        onClick={(e) =>
                                          handleAcceptReject(event_data.id, 11)
                                        }
                                      >
                                        Rejected
                                      </button>
                                    </div>
                                  </div>
                                )}
                              </>
                            )}
                          </center>
                        </div>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
          </div>
          <div id="react-paginate">
            <ReactPaginate
              breakLabel="..."
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              pageCount={pageCount}
              previousLabel="< previous"
              renderOnZeroPageCount={null}
              breakLinkClassName={"page-link"}
              containerClassName={"pagination"}
              pageLinkClassName={"page-link"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              activeClassName={"active"}
            />
          </div>
        </>
      )}
    </>
  );
};

export default AuditionCardReuse;
